import { fetchSecurityPinOpen } from '@api/useQueryCalls';
import { View } from '@components/primitives';
import useFeatureFlag from '@customHooks/useFeatureFlag';
import BottomSheet from '@molecules/LoginInfoSheet';
import navigationConstants from '@navigation/navigationConstants';
import { NavigationProps } from '@navigation/types';
import { useNavigation } from '@react-navigation/native';
import { FEATURE_FLAGS, SECURITY_PIN_INFO_MODAL } from '@root/constants';
import { FeatureFlagRecord } from '@root/types';
import { PinRegister } from '@root/types/securityPin';
import { getStore } from '@store/storeUtils';
import { returnBottomSheetContent } from '@utils/utils';
import React, { useEffect, useState } from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import profilePhoneChangeActiveBottomSheetHandler from './profilePhoneChangeRowUtils';

interface Props {
  childRef: React.MutableRefObject<any>;
}

const navigateToSecurityPin = navigation => {
  navigation.navigate(navigationConstants.GG_VERIFY_PIN_WITH_EXPIRY, {
    type: 'verifyPinWithExpiry',
    source: 'phone_change',
    onVerifyCallBack: () =>
      navigation.navigate(navigationConstants.GG_PHONE_NUMBER_CHANGE, {
        source: 'phone_change',
      }),
  });
};

const ProfilePhoneChangeRow: React.FC<Props> = (props: Props) => {
  const { childRef } = props;
  const navigation = useNavigation<NavigationProps>();
  const { pinRegister, setLoading } = getStore();

  const [infoModal, setInfoModal] = useState({
    visible: false,
    data: returnBottomSheetContent(SECURITY_PIN_INFO_MODAL.NEED_CREATE_PIN, SECURITY_PIN_INFO_MODAL.NEED_CREATE_PIN),
    errorCode: 'NEED_CREATE_PIN',
  });
  const [isFeatureAvailable] = useFeatureFlag({
    featureName: [FEATURE_FLAGS.SECURITY_PIN, FEATURE_FLAGS.PHONE_NUMBER_CHANGE],
  });

  const queryPinOpen = fetchSecurityPinOpen({
    payload: {
      screenName: 'changePhoneNumber',
    },
    onSuccess: data => {
      if (data) navigateToSecurityPin(navigation);
    },
  });

  const { checkPin, checkPinError, onPrimaryPress, onCloseModal } = profilePhoneChangeActiveBottomSheetHandler({
    setInfoModal,
    infoModal,
    navigation,
    pinRegister: pinRegister as PinRegister,
    isFeatureAvailable: isFeatureAvailable as FeatureFlagRecord[],
    queryPinOpen,
  });

  useEffect(() => {
    setLoading(queryPinOpen.isFetching);
  }, [queryPinOpen.isFetching]);

  // If Check Pin Failed Show Bottom Sheet
  useEffect(() => {
    if (queryPinOpen.isError && queryPinOpen.error) {
      checkPinError();
    }
  }, [queryPinOpen.isError, queryPinOpen.error]);

  return (
    <>
      <TouchableWithoutFeedback ref={childRef} testID="btnPressPhoneChange" onPress={() => checkPin()}>
        <View />
      </TouchableWithoutFeedback>
      <BottomSheet onPressPrimary={onPrimaryPress} loginInfo={infoModal} onClose={onCloseModal} />
    </>
  );
};

export default ProfilePhoneChangeRow;
